import { MatTableDataSource } from '@angular/material/table';
import { Subject } from 'rxjs';

export class FilterableMatTableDataSource<T> extends MatTableDataSource<T> {
  dataChange = new Subject<T[]>();

  constructor(data: T[] = []) {
    super(data);
    this.data = data;
  }

  set data(data: T[]) {
    if (this.data !== data) {
      super.data = data;
      this.dataChange.next(data);
    }
  }

  get data(): T[] {
    return super.data;
  }

  filterNumber(dataNumber?: number, filterNumber?: number): boolean {
    return !filterNumber || (dataNumber !== undefined && dataNumber === filterNumber);
  }

  filterString(dataString?: string, filterString?: string): boolean {
    return !filterString || dataString?.toLowerCase().includes(filterString.toLowerCase());
  }

  filterNumbers(dataNumbers?: number | number[], filterNumbers?: number[]): boolean {
    if (typeof dataNumbers === 'number') {
      dataNumbers = [dataNumbers];
    }
    if (dataNumbers === null || dataNumbers === undefined) {
      dataNumbers = [];
    }
    return (
      !filterNumbers ||
      filterNumbers.length === 0 ||
      (dataNumbers.length !== 0 && dataNumbers.some((val: number) => filterNumbers.includes(val)))
    );
  }

  filterStrings(dataStrings?: string | string[], filterStrings?: string[]): boolean {
    if (typeof dataStrings === 'string') {
      dataStrings = dataStrings?.split(',') || [];
    }
    if (dataStrings === null || dataStrings === undefined) {
      dataStrings = [];
    }
    return (
      !filterStrings ||
      filterStrings.length === 0 ||
      (dataStrings.length !== 0 && dataStrings.some((val: string) => filterStrings.includes(val)))
    );
  }
}
